import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { activationReducer } from './activation.reducer';
import { ActivationEffects } from './activation.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('activation', activationReducer),
    EffectsModule.forFeature([ActivationEffects])
  ]
})
export class ActivationStoreModule { }
